import { IdIdentifier, Timestamps, Timezone, UserIdentifier } from '../common';
import { SubtitlesConfig } from './subtitles';
import { AiAssetStyles, AssetOrigin } from '../asset';
import {
  SocialAccountMetadata,
  SocialProvider,
} from '../social-account/social-account';
import { ThumbnailConfig } from './thumbnail';

export type Video = IdIdentifier &
  Timestamps &
  UserIdentifier &
  VideoSettings & {
    seriesId?: string;
    title: string;
    script?: string;
    type?: VideoType;
    description?: string;
    status: VideoStatus;
    progress: VideoProgress[];
    videoUrl?: string;
    isRendering: boolean;
    renderProgress: number;
    renderFailures: number;
    hashtags: string[];
    aspectRatio: AspectRatio;
    renderDate?: Date;
    renderStartDate?: Date;
    renderRequested?: boolean;
    renderCounter: number;
    socialPublishInfo?: SocialPublishInfo;
    publishedAccounts?: PublishedAccount[];
    generatedAssets?: boolean;
    episodeNumber?: number;
    duration: number;
    isFavorite?: boolean;
    creationJobIds: string[];
    hardRetry?: boolean;
    characters?: Record<string, string>;
    migrateToPublishedSocialAccounts?: boolean;
  };

export enum VideoProgress {
  Scenes = 'scenes',
  Voiceover = 'voiceover',
  ScenesAssetsPrompts = 'scenesAssetsPrompts',
  Assets = 'assets',
}

export enum VideoStatus {
  Initial = 'initial',
  Ready = 'ready',
  Published = 'published',
  // AssetsCreationFailed = 'assets-failed',
  CreationFailed = 'creation-failed',
}

export enum AspectRatio {
  NineBySixteen = '9:16',
  SixteenByNine = '16:9',
  OneByOne = '1:1',
}

export enum VideoType {
  Empty = 'empty',
  Captions = 'captions',
  UGC = 'ugc',
  Clip = 'clip',
  Text = 'text',
}

export interface VideoSettings {
  voiceoverSpeed: number;
  voiceoverId: string;
  subtitlesConfig: SubtitlesConfig;
  language: string; // language ISO Code
  backgroundMusicId?: string;
  backgroundMusicUrl?: string;
  backgroundMusicVolume?: number;
  assetOrigin: AssetOrigin;
  assetStyle: VideoAssetStyle;
  options: VideoOptions;
  playbackRate?: number;
  thumbnailConfig: ThumbnailConfig;
}

export interface VideoOptions {
  enableAiMotions?: boolean;
}

export const defaultVideoOptions: VideoOptions = {
  enableAiMotions: false,
};

export const supportedAssetsOrigins = [
  AssetOrigin.StockImages,
  AssetOrigin.AIImages,
  AssetOrigin.StockVideos,
];

export type VideoAssetStyle = AiAssetStyles;

export interface SocialPublishInfo {
  publishAt?: Date;
  automaticPublishAt?: Date;
  needsReschedule?: boolean;
  timezone?: Timezone;
}

export interface PublishedAccount {
  socialAccountId: string;
  socialPlatform: SocialProvider;
  externalVideoId?: string;
  metadata?: SocialAccountMetadata;
  retryAmount?: number;
  actualPublishDate?: Date;
}
